import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=76fb608d&scoped=true&"
import script from "./GetStarted.vue?vue&type=script&lang=js&"
export * from "./GetStarted.vue?vue&type=script&lang=js&"
import style0 from "./GetStarted.vue?vue&type=style&index=0&id=76fb608d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fb608d",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QParallax from 'quasar/src/components/parallax/QParallax.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QParallax});
